  let testimonial_carousels = document.querySelectorAll(".module-testimonial .carousel");
  var myTestimonialCarousel = [];


  // updaet: after render is complete
  window.addEventListener('DOMContentLoaded', (event) => {

    if (testimonial_carousels.length) {
      for (var i = 0; i < testimonial_carousels.length; i++) {
        testimonial_carousels[i].classList.add('bo-testimonial-carousel-' + i);

        myTestimonialCarousel[i] = new Carousel(document.querySelector('.bo-testimonial-carousel-' + i), {
          'slidesPerPage': 'auto',
          'infinite': true,
          //'initialPage': 1,
          'center': false,
          'friction': 0.8,
          Navigation: {
            prevTpl: '<svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12.3px" height="22.1px" viewBox="0 0 12.3 22.1" <g transform="rotate(180)"><polyline points="-0.5,20.7 9.7,10.3 -0.5,0"/></g></svg>',
            nextTpl: '<svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12.3px" height="22.1px" viewBox="0 0 12.3 22.1" <g transform="rotate(0)"><polyline points="-0.5,20.7 9.7,10.3 -0.5,0"/></g></svg>',
          },
          Dots: false,
          on: {
            init: (carousel) => {},
            refresh: (carousel) => {},
            change: (carousel) => {},
            ready: (carousel) => {},
          },
        });
      }

    }
  });